/* J'ADORE — sklep na telefonie (19.09.2026). Para do `jadore-mobile.css`.

   Podaje w `--jad-dol` wysokosc tego, co akurat stoi przy dolnej krawedzi ekranu:
   dolnego menu telefonu (`mobile-sticky-bar`) albo paska produktu karty marki
   (`#egSticky` i odmiany). Czat i przycisk "Znajdz produkt" ustawiaja sie nad tym,
   zamiast lezec na przyciskach.

   Bez nasluchu przewijania: oba paski zmieniaja stan przez klase (`up`/`down`, `on`),
   wiec wystarczy MutationObserver. Na ekranie od 768 px zmienna ma zawsze 0 px. */
(function () {
  var root = document.documentElement;
  var mq = window.matchMedia('(max-width: 767px)');
  var SEL = 'mobile-sticky-bar, #egSticky, #HpSticky, #BioSticky, #PcaSticky';
  var els = [];
  var t = 0;

  function licz() {
    var dol = 0;
    if (mq.matches) {
      els.forEach(function (el) {
        var h = el.offsetHeight;
        if (!h) return; /* display:none, np. dolne menu na karcie produktu */
        var widac = el.tagName === 'MOBILE-STICKY-BAR' ? !el.classList.contains('down') : el.classList.contains('on');
        if (widac && h > dol) dol = h;
      });
    }
    root.style.setProperty('--jad-dol', dol + 'px');
  }

  function plan() {
    clearTimeout(t);
    t = setTimeout(licz, 60);
  }

  /* Serce na kartach marek to <button> z sama ikona - czytnik ekranu mowil "przycisk".
     Nazwa w jezyku strony; gdy jezyka nie ma na liscie, wypada polski (jezyk glowny). */
  var ULUBIONE = {
    pl: 'Dodaj do ulubionych', en: 'Add to favourites', de: 'Zu Favoriten hinzufügen',
    es: 'Añadir a favoritos', fr: 'Ajouter aux favoris', it: 'Aggiungi ai preferiti',
    nl: 'Toevoegen aan favorieten', pt: 'Adicionar aos favoritos', sv: 'Lägg till i favoriter',
    nb: 'Legg til i favoritter', el: 'Προσθήκη στα αγαπημένα', ru: 'Добавить в избранное',
    uk: 'Додати до обраного'
  };
  function jezyk() {
    return (root.lang || 'pl').slice(0, 2).toLowerCase();
  }
  function nazwijSerca() {
    var napis = ULUBIONE[jezyk()] || ULUBIONE.pl;
    document.querySelectorAll('button[onclick*="Heart("]:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', napis);
    });
  }

  function start() {
    nazwijSerca();
    podpowiedziSzukajki();
    els = Array.prototype.slice.call(document.querySelectorAll(SEL));
    if (window.MutationObserver) {
      var mo = new MutationObserver(plan);
      els.forEach(function (el) {
        mo.observe(el, { attributes: true, attributeFilter: ['class', 'hidden'] });
      });
    }
    if (mq.addEventListener) mq.addEventListener('change', plan);
    else if (mq.addListener) mq.addListener(plan);
    window.addEventListener('resize', plan, { passive: true });
    window.addEventListener('load', plan);
    licz();
  }

  /* Szuflada "Szukaj" byla pusta, dopoki nic sie nie wpisalo (motyw nie ma ustawionych
     "popularnych wyszukiwan"). Pod polem pokazujemy marki z menu (window.__JADORE_MENU);
     znikaja, gdy klientka zaczyna pisac i pojawiaja sie podpowiedzi produktow. */
  var POPULARNE = {
    pl: 'Popularne marki', en: 'Popular brands', de: 'Beliebte Marken', es: 'Marcas populares',
    fr: 'Marques populaires', it: 'Marchi popolari', nl: 'Populaire merken', pt: 'Marcas populares',
    sv: 'Populära märken', nb: 'Populære merker', el: 'Δημοφιλείς μάρκες', ru: 'Популярные бренды',
    uk: 'Популярні бренди'
  };
  function podpowiedziSzukajki() {
    var form = document.querySelector('#SearchDrawer form');
    var pole = form && form.querySelector('input[name="q"]');
    var dane = window.__JADORE_MENU && window.__JADORE_MENU.groups;
    if (!form || !pole || !dane || form.querySelector('.jad-szuk-pop')) return;
    var marki = [];
    dane.forEach(function (g) { if (g.key === 'dermokosmetyki') marki = g.brands || []; });
    if (!marki.length) return;
    var blok = document.createElement('div');
    blok.className = 'jad-szuk-pop';
    var tyt = document.createElement('div');
    tyt.className = 'jad-szuk-pop__tyt';
    tyt.textContent = POPULARNE[jezyk()] || POPULARNE.pl;
    blok.appendChild(tyt);
    var lista = document.createElement('div');
    lista.className = 'jad-szuk-pop__lista';
    marki.slice(0, 12).forEach(function (m) {
      if (!m.url || !m.name) return;
      var a = document.createElement('a');
      a.className = 'jad-szuk-pop__chip';
      a.href = m.url;
      a.textContent = m.name;
      lista.appendChild(a);
    });
    blok.appendChild(lista);
    var pasek = form.querySelector('.search__field');
    if (pasek && pasek.parentNode) pasek.parentNode.insertBefore(blok, pasek.nextSibling);
    else form.appendChild(blok);
    var odswiez = function () { blok.hidden = !!pole.value.trim(); };
    pole.addEventListener('input', odswiez);
    form.addEventListener('reset', function () { setTimeout(odswiez, 0); });
    odswiez();
  }

  /* Karta produktu na liscie: przyciski - / + przy ilosci (card-product.liquid, .jad-qty).
     Jeden nasluch na dokument, wiec dziala tez dla kart doladowanych filtrem albo "pokaz wiecej". */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-jad-qty]') : null;
    if (!b) return;
    e.preventDefault();
    var pole = b.parentNode && b.parentNode.querySelector('.jad-qty__input');
    if (!pole) return;
    var v = (parseInt(pole.value, 10) || 1) + (parseInt(b.getAttribute('data-jad-qty'), 10) || 0);
    pole.value = Math.min(99, Math.max(1, v));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Dlugi opis marki na telefonie: zakladki zamiast sciany tekstu (20.09.2026).

   Cialo redakcyjne produktu (metapole `*_pdp_body`) to ciag sekcji, kazda z wlasnym <h2>.
   Na estGen bylo ich dziesiec i strona miala 21 831 px na iPhonie — do przycisku doboru
   trzeba bylo przewijac przez caly artykul. Sekcja w motywie oznacza poczatek i koniec
   tego ciala znacznikami `.jd-czytnik-start` / `.jd-czytnik-koniec`, a tu zamieniamy je
   na spis rozdzialow i skladane pozycje. Tylko do 749 px; na tablecie i komputerze
   uklad zostaje bez zmian. Tresc zostaje w DOM, wiec wyszukiwarki widza ja jak wczesniej. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var zlozone = false;
  var pozycje = [];

  function waski() {
    return mq.matches;
  }

  function tekst(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function zloz() {
    if (zlozone) return;
    var poczatek = document.querySelector('.jd-czytnik-start');
    var koniec = document.querySelector('.jd-czytnik-koniec');
    if (!poczatek || !koniec || poczatek.parentNode !== koniec.parentNode) return;

    /* Czesc generatorow stawia sekcje wprost miedzy znacznikami, czesc owija je
       w jeden <div> — w tym drugim wypadku schodzimy poziom nizej. */
    var rodzenstwo = [];
    for (var el = poczatek.nextElementSibling; el && el !== koniec; el = el.nextElementSibling) {
      rodzenstwo.push(el);
    }
    var glebokosc = 0;
    var zrodlo = null;
    while (rodzenstwo.length === 1 && rodzenstwo[0].children.length > 1 && glebokosc < 3) {
      zrodlo = rodzenstwo[0];
      rodzenstwo = [].slice.call(zrodlo.children);
      glebokosc++;
    }
    var sekcje = rodzenstwo.filter(function (e) {
      return e.tagName === 'SECTION' && e.querySelector('h2');
    });
    /* Ponizej trzech rozdzialow skladanie nic nie daje, a zabiera zdjecia i naglowki. */
    if (sekcje.length < 3) return;
    zlozone = true;

    var czytnik = document.createElement('div');
    czytnik.className = 'jd-czytnik';
    /* Gdy sekcje siedzialy w opakowaniu (np. pHformula: `max-width:1180px; padding:0 40px`),
       to ono trzyma je w linii z reszta strony na komputerze. Czytnik wchodzi wiec do srodka,
       w miejsce pierwszej sekcji — inaczej tresc wysypywala sie do lewej krawedzi ekranu.
       Na telefonie opakowanie dostaje zerowe marginesy (CSS), bo czytnik ma tam wlasne. */
    if (zrodlo) {
      zrodlo.classList.add('jd-czytnik-ramka');
      zrodlo.insertBefore(czytnik, sekcje[0]);
    } else {
      koniec.parentNode.insertBefore(czytnik, koniec);
    }

    var spis = document.createElement('div');
    spis.className = 'jd-czytnik__spis';
    czytnik.appendChild(spis);

    sekcje.forEach(function (sek, i) {
      var h2 = sek.querySelector('h2');
      var tytul = tekst(h2);

      var poz = document.createElement('details');
      poz.className = 'jd-czytnik__poz';
      /* Na telefonie otwarty jest jeden rozdzial, na szerokim ekranie wszystkie —
         tam spis sluzy do skakania po tresci, a nic sie nie chowa. */
      poz.open = !waski() || i === 0;

      var naglowek = document.createElement('summary');
      naglowek.className = 'jd-czytnik__tytul';
      var nap = document.createElement('span');
      nap.textContent = tytul;
      naglowek.appendChild(nap);
      poz.appendChild(naglowek);

      var tresc = document.createElement('div');
      tresc.className = 'jd-czytnik__tresc';
      poz.appendChild(tresc);

      czytnik.appendChild(poz);
      tresc.appendChild(sek); /* cala sekcja idzie do srodka, bez ruszania jej wnetrza */
      h2.classList.add('jd-czytnik__h2-ukryty');
      pozycje.push(poz);

      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'jd-czytnik__chip';
      chip.textContent = tytul;
      chip.addEventListener('click', function () {
        otworz(poz);
        try {
          poz.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (_) {
          poz.scrollIntoView();
        }
      });
      spis.appendChild(chip);
    });

    /* Na telefonie jeden rozdzial otwarty na raz — inaczej po kilku dotknieciach
       wraca ta sama sciana tekstu. Na szerokim ekranie nic nie zamykamy. */
    function otworz(poz) {
      pozycje.forEach(function (p) {
        if (waski()) p.open = p === poz;
        else if (p === poz) p.open = true;
      });
      oznacz();
    }

    function oznacz() {
      pozycje.forEach(function (p, i) {
        var chip = spis.children[i];
        if (chip) chip.classList.toggle('jest-otwarty', p.open);
      });
    }

    pozycje.forEach(function (p) {
      p.addEventListener('toggle', function () {
        if (p.open) otworz(p);
        else oznacz();
      });
    });
    oznacz();
  }

  /* Przejscie telefon <-> szerszy ekran: dopasuj, co ma byc otwarte. */
  function dopasuj() {
    zloz();
    if (!pozycje.length) return;
    pozycje.forEach(function (p, i) {
      p.open = !waski() || i === 0;
    });
  }

  /* Zakladki generatora (details.sec / details.acc: "Plan krok po kroku", "Skladniki",
     "Stosowanie", "Pelny sklad INCI") otwieraly sie jedna na drugiej i po kilku
     dotknieciach znowu robila sie sciana tekstu. Zamykamy rodzenstwo z tego samego
     pojemnika — czyli jedna grupe zakladek; zagniezdzonych i cudzych nie ruszamy,
     bo maja innego rodzica. Zdarzenie `toggle` nie bulgocze, stad faza przechwytywania.
     Dotyczy telefonu i komputera; rozdzialow na komputerze nie zwijamy w ogole. */
  var GRUPA = 'details.sec, details.acc';
  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (!d || !d.open || !d.matches || !d.matches(GRUPA) || !d.parentElement) return;
      [].forEach.call(d.parentElement.children, function (inny) {
        if (inny === d || !inny.matches || !inny.matches(GRUPA) || !inny.open) return;
        inny.open = false;
      });
    },
    true
  );

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', zloz);
  else zloz();
  /* Obrot telefonu albo zmiana szerokosci okna. */
  if (mq.addEventListener) mq.addEventListener('change', dopasuj);
  else if (mq.addListener) mq.addListener(dopasuj);
})();
